 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		41: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		41: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"brr-widget","1":"chat-action","2":"chat-advertisment","3":"chat-auto-message","4":"chat-bottom-panel","5":"chat-button-menu","6":"chat-cookie-consent","7":"chat-credit-card","8":"chat-date","9":"chat-date-time","10":"chat-details-page","11":"chat-disclaimer","12":"chat-email","13":"chat-evaluation-modal","14":"chat-image","15":"chat-image-list","16":"chat-language","17":"chat-login","18":"chat-media","19":"chat-multi-select","20":"chat-notification","21":"chat-quick-reply","22":"chat-recommender","23":"chat-redactor-view","24":"chat-request-list","25":"chat-select-channel","26":"chat-selector","27":"chat-slider","28":"chat-template","29":"chat-upload-error","30":"chat-user-evaluation","31":"chat-users","32":"chat-window","33":"locale-ar","34":"locale-id","35":"locale-ja","36":"locale-ko","37":"locale-th","38":"locale-zh-hans","39":"locale-zh-hant","40":"terms-conditions-modal","42":"triplabot","44":"vendors~chat-credit-card","45":"vendors~chat-slider","46":"vendors~chat-template","47":"vendors~triplabot"}[chunkId]||chunkId) + "." + {"0":"338b6905ed04216f66d5","1":"87c1cd9b0976bb73055f","2":"aedf5b5e4d2099dff37e","3":"3fc391e6502298aa45fa","4":"1f4f9a726d91d986a249","5":"e1c3119651bb416a5d83","6":"53b2dadf755ed83ee49e","7":"53e2410e2f3ce37c8057","8":"f1666e2307f3e8309beb","9":"da3ef402aa9c5b954eab","10":"df58b0d4d5239e1628fb","11":"6eac5cd51af0b58950f3","12":"97cc41da263bdd78a954","13":"b5e6e01ae0eeca170893","14":"7a02e4169fe6736c517e","15":"81ebf4a2586c0516d35e","16":"236a80adb843d80bc51a","17":"3b35adc51d76ed87bc7b","18":"ec405a080adc3def66b6","19":"3a776de7f50e5c48788e","20":"b854937ff65fb9cb6c6e","21":"afeb1829d0e53610ce5b","22":"554fadb1a39056cc4624","23":"00c7c75bc04c569c80be","24":"c26e9ce5d57537beacdc","25":"c6110f8681e2421a77a9","26":"128810868ba824c05f61","27":"a80807660e962de434b8","28":"50eb31edd84e1d1c9774","29":"d6b1acb9e8f7992c3ec2","30":"1ebac950e396ed53744d","31":"3fd3981bd080b640f9db","32":"453694c3f561efa54ec6","33":"729073d4375b5413ae0f","34":"291efc00a715d91106d9","35":"8c37f4aa309ae87a2081","36":"eac463b5f18e14fa82db","37":"f6bdfceb45b41f7e85f6","38":"51ad14771f29b612fa1d","39":"68b0483bd89b3f2655f3","40":"4cf3faec6fca2722c099","42":"ab7c6e67fbbc1425c4ae","44":"4bd1b90ade935f8271bf","45":"62916dae5c677b38d344","46":"06f039cc9a4cfe50beac","47":"855270e2aef941bb2478"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"4":1,"10":1,"15":1,"18":1,"19":1,"20":1,"23":1,"26":1,"27":1,"30":1,"31":1,"32":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + chunkId + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"492416ed5747aaa7ea63","3":"31d6cfe0d16ae931b73c","4":"d0561382629be57cfd8e","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"099ffafac35804faca2c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"4326eed78a2ca8deede8","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"6a3f9534e4af226ea738","19":"5c003ae60b8c268966af","20":"141eb13a89b252f4e65e","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"6c5f8fcf2fb1e5e15fad","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"0fbb569a48399b06eba6","27":"eb1a957c618e18f917f0","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"5c003ae60b8c268966af","31":"cd2dd2c78b48d373c8e6","32":"9ca89042879ad9b33672","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				(function (linkTag) {
 				          linkTag.addEventListener('load', function () {
 				            if (window.__onCSSLoaded) window.__onCSSLoaded()

 				            // Inject chunk CSS into iframes where components render
 				            const iframeIds = ['#tripla-chat-window', '#tripla-icon-message', '#terms-conditions-modal']
 				            for (let i = 0; i < iframeIds.length; i++) {
 				              const iframe = document.querySelector(iframeIds[i])
 				              if (iframe && iframe.contentDocument) {
 				                iframe.contentDocument.head.appendChild(linkTag.cloneNode(true))
 				              }
 				            }
 				          })
 				          const linkTags = window.__triplabotLinkTags || []
 				          linkTags.push(linkTag)
 				          window.__triplabotLinkTags = linkTags
 				          document.head.appendChild(linkTag)
 				        })(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.definePropertySafe(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.definePropertySafe(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.definePropertySafe(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.definePropertySafe(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://s3-ap-northeast-1.amazonaws.com/triplabot-staging/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonptriplabot"] = window["webpackJsonptriplabot"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 3);
